import { LoginAPIInstance } from "@/api";

const auth_url = 'token/';
const reg_url = 'users/';
const verification_url = 'users/email-verify/'
const recovery_pass_url = 'users/password-reset-email/';
const recovery_pass_phone_url = 'users/password-reset-phone/';
const recovery_pass_complate_url ='users/password-reset-complete/';
const reactivated_url = 'user/reactivate/'

export const AuthAPI = {
    login(userData) {
        return LoginAPIInstance.post(auth_url, userData)
    },
    verification(token) {
        return LoginAPIInstance.get(verification_url, {params: {token: token}})
    },
    registration(userData) {
        return LoginAPIInstance.post(reg_url, userData)
    },
    recoveryPassword(emailData) {
        return LoginAPIInstance.post(recovery_pass_url, emailData)
    },
    recoveryPasswordPhone(phoneData){
        return LoginAPIInstance.post(recovery_pass_phone_url, phoneData)
    },
    resetComplatePassword(passData) {
        return LoginAPIInstance.patch(recovery_pass_complate_url, passData)
    },
    sendActivateMessage(idClient) {
        return LoginAPIInstance.post(reactivated_url, idClient)
    }
}